import { api } from './api';
import type { EscalationRule } from '@/types/notification';

interface ListRulesResponse {
  data: EscalationRule[];
}

interface RuleResponse {
  data: EscalationRule;
}

interface AcknowledgeResponse {
  data: { notification_id: string; user_id: string; acknowledged_at: string };
  message: string;
}

export const escalationService = {
  // Escalation Rules
  async listRules(resourceType?: string): Promise<EscalationRule[]> {
    const params = resourceType ? { resource_type: resourceType } : undefined;
    const response = await api.get<ListRulesResponse>('/escalation/rules', params);
    return response.data;
  },

  async getRuleById(id: string): Promise<EscalationRule> {
    const response = await api.get<RuleResponse>(`/escalation/rules/${id}`);
    return response.data;
  },

  async createRule(data: Partial<EscalationRule>): Promise<EscalationRule> {
    const response = await api.post<RuleResponse>('/escalation/rules', data);
    return response.data;
  },

  async updateRule(id: string, data: Partial<EscalationRule>): Promise<EscalationRule> {
    const response = await api.put<RuleResponse>(`/escalation/rules/${id}`, data);
    return response.data;
  },

  async deleteRule(id: string): Promise<void> {
    await api.delete('/escalation/rules/' + id);
  },

  // Notification Acknowledgement
  async acknowledgeNotification(
    notificationId: string,
    data?: { notes?: string; auto_action?: string }
  ): Promise<void> {
    await api.post<AcknowledgeResponse>(
      `/escalation/notifications/${notificationId}/acknowledge`,
      data || {}
    );
  },
};
